import React from 'react';
import PropTypes from 'prop-types';

const Window = ({ color = '#224251', ...props }) => (
  <svg width={25} height={32} viewBox="0 0 25 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      clipRule="evenodd"
      d="M21.102 28.39H3.108V1h17.994v27.39Zm2.57 0H.537V31h23.136v-2.61Z"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M3.2 14.657h17.076M12.124 1.465v26.274V1.465Z" stroke="#224251" strokeLinecap="square" />
  </svg>
);

Window.propTypes = {
  color: PropTypes.string
};

export default Window;
